import { Component } from '@verndale/core';
import 'slick-carousel';

class StatsList extends Component {
  setupDefaults() {
    this.dom = {
      $slider: this.el.querySelector('.testimonials__items'),
      $quotes: this.el.querySelectorAll('.testimonial'),
      $prev: this.el.querySelector('.testimonials__arrow--prev'),
      $next: this.el.querySelector('.testimonials__arrow--next')
    };

    this.slide();
  }

  addListeners() {
    $(this.dom.$slider).on('click', '.testimonial', ::this.moveTo)
  }

  slide() {
    $(this.dom.$slider).slick({
      arrows: false,
      dots: true,
      mobileFirst: true,
      centerMode: true,
      variableWidth: true,
      prevArrow: this.dom.$prev,
      nextArrow: this.dom.$next,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: true,
            dots: false
          }
        }
      ]
    })
  }

  moveTo(e) {
    const $slide = e.currentTarget;
    const index = parseInt($slide.closest('.slick-slide').getAttribute('data-slick-index'));

    $(this.dom.$slider).slick('slickGoTo', index);
  }
}

export default StatsList;
